import { ProgressBar } from '@unmind/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface CourseProgressProps {
  daysCompleted: number;
  totalDays: number;
}

export const CourseProgress = ({
  daysCompleted,
  totalDays,
}: CourseProgressProps) => {
  const { t: translate } = useTranslation('courses');

  const courseProgress = Math.round((daysCompleted / totalDays) * 100);

  if (courseProgress === 0) {
    return null;
  }

  return (
    <ProgressBar
      progress={courseProgress}
      label={translate('course_card.progress_indicator.text', {
        courseProgress: courseProgress,
      })}
    />
  );
};
